import { render, staticRenderFns } from "./BackupSettings.vue?vue&type=template&id=3f5f83f4&scoped=true&"
import script from "./BackupSettings.vue?vue&type=script&lang=js&"
export * from "./BackupSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5f83f4",
  null
  
)

export default component.exports